<template>
  <footer>
    <div class="footer_left">
      &copy; 2010 - Jeffrey's Hamburgers - All Rights Reserved. <a href="#">Sitemap</a>
    </div>

    <div class="footer_right">
      <div class="footer_twitter">
        <a href="https://twitter.com/jeffreysburgers" target="_blank">
          <img src="assets/images/clr.png" style="width:105px; height:20px;">
        </a>
      </div>

      <img src="assets/images/footer_greyline.png" style="float:left; margin:-10px 15px 0 15px;" />

      <div class="footer_facebook">
        <a href="http://www.facebook.com/pages/Jeffreys-Hamburgers/183341132361" target="_blank">
          <img src="assets/images/clr.png" style="width:105px; height:20px;" />
        </a>
      </div>

      <div id="preload">
        <img src="assets/images/nav_homeon.png" width="1" height="1">

        <img src="assets/images/nav_menuon.png" width="1" height="1">

        <img src="assets/images/nav_locationson.png" width="1" height="1">

        <img src="assets/images/nav_aboutuson.png" width="1" height="1">

        <img src="assets/images/nav_orderon.png" width="1" height="1">

        <img src="assets/images/nav_contacton.png" width="1" height="1">

        <img src="assets/images/footer_facebook.png" width="1" height="1">

        <img src="assets/images/footer_twitter.png" width="1" height="1">
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'TheFooter',
};
</script>
